import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBadgeCheck } from '@fortawesome/pro-solid-svg-icons';
import CreateTrialForm from './CreateTrialForm';
import logoBlack from 'assets/crafter-logo-black.png';
import '../../style/scss/account.scss';

const CreateTrialPage = () => {
    const { t } = useTranslation();

    const benefits = [
        "complete_process",
        "clear_software",
        "grip_and_rest",
        "clear_what_to_do",
        "quick_implementation",
        "renewed_2026"
    ]

    return (
        <div className='create-trial'>
            <div className='left-panel'>
                <div className='logo-container'>
                    <img src={logoBlack} alt="Logo" className='trial-logo'/>
                </div>
                <div className='form'>
                    <div className='header'>
                        <h1>
                            {t('account.create_account_header_label')}
                        </h1>
                        <p className='subtitle'>
                            {t('account.create_account_header_description')}
                        </p>
                    </div>
                    <CreateTrialForm />
                    <p className='remarks'>
                        {t('account.create_account_remarks')}
                    </p>
                    <div className='login'>
                        <div className='login-container'>
                            <p className='pr-1'>
                                {t('account.already_a_user_label')}
                            </p>
                            <Link to={'/login'}>
                                <p className='login-link'>
                                    {t('account.log_in_link')}
                                </p>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
            <div className='right-panel'>
                <div className='login'>
                    <div className='login-container'>
                        <p className='pr-1'>
                            {t('account.already_a_user_label')}
                        </p>
                        <Link to={'/login'}>
                            <p className='login-link'>
                                {t('account.log_in_link')}
                            </p>
                        </Link>
                    </div>
                </div>
                <div className='benefits'>
                    <div className='benefits-container'>
                        <h4 className='title'>
                            {t('account.create_account_benefits_title')}
                        </h4>
                        <ul className="benefit-list">
                            {benefits.map((benefit, index) => (
                                <li key={index} className='benefit-item'>
                                    <FontAwesomeIcon icon={faBadgeCheck} className='benefit-icon' /> 
                                    {t(`account.benefit.${benefit}`)}
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CreateTrialPage;